import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_1Screen } from "../SlotGameType1_1Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {
    export class TikiBayClassic_1Screen extends SlotGameType1_1Screen {
        // override default factory with one that creates custom freegame

        

        //protected override helpFactory: IHelpFactory = new TikiBayClassicHelpFactory();

        //LED COLOR
		protected override ColorLed:string="36,255,149\n";

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "TikiBayClassic") {
            super(multigameParams, initData, gameName);
            this.spinnableReelsParams.topBorderWidth = 6;
            this.spinnableReelsParams.bottomBorderWidth = 6;
        }
    }

    class TikiBayClassicHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new TikiBayClassicHelp(params);
        }
    }

    class TikiBayClassicHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(2, 38, 1),rgb(3, 64, 1), rgb(85, 140, 3),rgb(3, 64, 1),rgb(2, 38, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }


// }
